import { evolve, set, compose, lensPath } from 'ramda';
import { EmployeeContractsActions } from 'src/store/actions/employeesContractsActions';
import { requestEvolve, successEvolve } from './reducerUtill';
const initialState = {
    allContracts: [],
    list: {},
    pending: false,
    multipleUpdateFetching: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case EmployeeContractsActions.LOADING_ALL_EMPLOYEES_CONTRACTS:
            return { ...state, pending: true };
        case EmployeeContractsActions.ERROR_LOADING_ALL_EMPLOYEES_CONTRACTS:
            return { ...state, pending: false };
        case EmployeeContractsActions.SAVE_ALL_EMPLOYEES_CONTRACTS:
            return {
                ...state, pending: false, allContracts: payload.allContracts, list: payload.list
            };
        case EmployeeContractsActions.LOADING_EMPLOYEE_CONTRACTS:
            return evolve(requestEvolve, state);
        case EmployeeContractsActions.SAVE_EMPLOYEE_CONTRACTS: {
            const { userId, list } = payload;
            return compose(evolve(successEvolve), set(lensPath(['list', userId]), list))(state);
        }
        case EmployeeContractsActions.UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS:
            return ({ ...state, multipleUpdateFetching: true });
        case EmployeeContractsActions.SUCCESS_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS:
        case EmployeeContractsActions.ERROR_UPDATING_MULTIPLE_EMPLOYEE_CONTRACTS:
            return ({ ...state, multipleUpdateFetching: false });
        case EmployeeContractsActions.SAVE_NEW_EMPLOYEE_CONTRACT: {
            const { raw, decapitalized } = payload;
            return {
                ...state,
                allContracts: [...state.allContracts, raw],
                list: { ...state.list, [decapitalized.userId]: { ...(state.list[decapitalized.userId] || []), [decapitalized.id]: decapitalized } }
            };
        }
        case EmployeeContractsActions.UPDATE_EMPLOYEE_CONTRACT: {
            const { raw, decapitalized } = payload;
            return {
                ...state,
                allContracts: state.allContracts.map((contract) => (contract.Id === raw.Id ? raw : contract)),
                list: { ...state.list, [decapitalized.userId]: { ...state.list[decapitalized.userId], [decapitalized.id]: decapitalized } }
            };
        }
        default:
            return state;
    }
};
